import React, { useCallback, useContext, useEffect, useState } from 'react'
import { useDispatch, useSelector  } from 'react-redux'
import MessengerDrawer from '../features/views/Chat'
import ListView from '../features/views/Threads'
import NewThreadView from '../features/views/NewThread'
import { viewContext } from '../context/viewContext'
import { VIEWS } from '../features/views/views'
import { userContext } from '../../shared/context/userContext'
import { usePaginate } from '../common/usePaginate'
import { updateOwner as updateNewComments } from '../features/new_messages'
import { fetchInitialLoad } from '../features/owners/fetchInitialLoad'

const MessengerWrapper = ({ page, setPage, setTotal, PaginationComponent, setActiveThreadId, activeThreadId, drawerOpen, setDrawerOpen, setOpenMessenger }) => {
  const dispatch = useDispatch()
  const { currentView, unique_owner_id, threadsPerPage, setFocusId } = useContext(viewContext)
  const [shouldRefetch, setShouldRefetch] = useState(false)
  const [messagesPage, setMessagesPage] = useState({})

  // close handler for drawer
  const handleClose = useCallback(() => {
    if (shouldRefetch) {
      dispatch(fetchInitialLoad({ unique_owner_id, perPage: threadsPerPage, page: 1 }))
      setPage(1)
    }
    setShouldRefetch(false)
    setDrawerOpen(false)
    setActiveThreadId(null)
    setFocusId(null)
  }, [shouldRefetch, unique_owner_id])

  return (
    <div className="messenger-wrapper">
      <div className="dome-relative">
        {currentView === VIEWS.LIST_VIEW && (
          <MessengerDrawer
            activeThreadId={activeThreadId}
            drawerOpen={drawerOpen}
            onClose={handleClose}
            shouldRefetch={shouldRefetch}
            setShouldRefetch={setShouldRefetch}
            threadPage={page}
            page={messagesPage}
            setPage={setMessagesPage}
          />
        )}
        <div className={`messenger dome-light-shadow dome-rounded-border dome-full-width ${drawerOpen ? 'open' : ''}`}>
          {currentView === VIEWS.LIST_VIEW && (
            <ListView
              setActiveThreadId={setActiveThreadId}
              drawerOpen={drawerOpen}
              setDrawerOpen={setDrawerOpen}
              page={page}
              setThreadPage={setPage}
              setTotal={setTotal}
              PaginationComponent={PaginationComponent}
              setMessagesPage={setMessagesPage}
              setOpenMessenger={setOpenMessenger}
            />
          )}
          {currentView === VIEWS.NEW_MESSAGE_VIEW && <NewThreadView page={page} />}
        </div>
      </div>
    </div>
  )
}

const MessengerToggle = ({ handleClick, page, openMessenger }) => {
  const { unique_owner_id } = useContext(viewContext)
  const totalUnreadMessages = useSelector(state => state.new_messages?.data[unique_owner_id] || 0)

  const [hovered, setHovered] = useState(false)
  const messageIconClasses = ['fa-messages']
  
  messageIconClasses.push(totalUnreadMessages > 0 ? 'dome-color-aqua' : 'dome-color-dark-grey')
  messageIconClasses.push(hovered ? 'fas' : 'fal')
  const unreadCountText = totalUnreadMessages > 9 ? `9+` : `${totalUnreadMessages}`

  const handleMouseEnter = () => setHovered(true)
  const handleMouseLeave = () => setHovered(false)

  return (
    <div className='message-toggle-container dome-d-flex dome-justify-end dome-align-center'>
      <div
        className="message-toggle dome-d-flex dome-justify-end dome-gap3 dome-align-center"
        style={{ cursor: 'pointer', paddingInline: '17px' }}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        onClick={handleClick}
      >
        <i className={messageIconClasses.join(' ')} style={{ fontSize: '20px' }} />
        {totalUnreadMessages > 0 && <span className="dome-color-aqua">{`${unreadCountText} new`}</span>}
        {openMessenger && <i className="fa-solid fa-caret-up"></i>}
      </div>
    </div>
  )
}

const App = ({defaultOpen = false, newMessages =  null}) => {
  const { threadsPerPage, unique_owner_id, focusId } = useContext(viewContext)
  const { page, setPage, setTotal, Component: PaginationComponent } = usePaginate({ perPage: threadsPerPage })
  const [openMessenger, setOpenMessenger] = useState(focusId ? true : defaultOpen)
  const [activeThreadId, setActiveThreadId] = useState(null)
  const [drawerOpen, setDrawerOpen] = useState(false)
  const dispatch = useDispatch()

  useEffect(() => {
    if (newMessages)
      dispatch(updateNewComments({ owner: unique_owner_id, count: newMessages }))
  }, [newMessages, unique_owner_id])

  const handleClick = useCallback(() => {
    setOpenMessenger(!openMessenger)

  }, [openMessenger, dispatch])


  return (
    <div className="messaging-app dome-relative">
      <MessengerToggle
        unique_owner_id={unique_owner_id}
        handleClick={handleClick}
        page={page}
        openMessenger={openMessenger}
      />
      {openMessenger && (
        <MessengerWrapper
          page={page}
          setPage={setPage}
          setTotal={setTotal}
          PaginationComponent={PaginationComponent}
          activeThreadId={activeThreadId}
          setActiveThreadId={setActiveThreadId}
          drawerOpen={drawerOpen}
          setDrawerOpen={setDrawerOpen}
          setOpenMessenger={setOpenMessenger}
        />
      )}
    </div>
  )

}

export default App
